<app-overview [query]="query" (dataChange)="keys = $event" [windowScroll]="true">
    <div class="header-bar align-items-center row ">
        <div class="row justify-content-between align-items-center mb-5">
            <div class="col-12 col-md-9 col-xl-7">
                <p class="text-muted">
                    The Flowmaps API provides secure access to organization and meter data for third-party applications. For more information on how to use the API, refer to the <a href="https://apidocs.flowmaps.com/" target="_blank" class="text-primary">documentation</a>.
                </p>
            </div>
            <div class="col-12 col-xl-auto">
                <button (click)="generateApiKey()" type="button" class="btn btn-primary">
                    <i class="bi bi-plus me-2"></i>
                    <span class="d-none d-md-inline">Generate New API Key</span>
                </button>
            </div>
        </div>
    </div>
    <div class="overview-items row">
        <ng-container *ngFor="let record of keys; trackBy: trackByForRecord">
            <div class="col-12 col-xl-6 mb-4">
                <app-api-keys-overview-item [apiKey]="record"></app-api-keys-overview-item>
            </div>
        </ng-container>
    </div>
    <div *ngIf="!keys.length" class="empty-container text-center py-5 text-muted">
        <i class="fe fe-folder fe-32 mb-3"></i>
        <p class="mb-1">No API keys found</p>
        <span class="text-secondary"> To get started, you can</span>
        <span class="text-primary pointer" (click)="generateApiKey()">add a new API key.</span>
    </div>
</app-overview>
